import type { TabItemType } from 'enable-ui';

import { LEARNER_DETAIL } from './enum';

export const getLearnerDetailTabs = (id: string): TabItemType[] => {
  return [
    {
      label: 'Profile',
      key: LEARNER_DETAIL.PROFILE,
      children: <></>,
    },
    // {
    //   label: 'Lesson schedule',
    //   key: LEARNER_DETAIL.LESSON_SCHEDULE,
    //   children: <></>,
    // },
    {
      label: 'Class results',
      key: LEARNER_DETAIL.CLASS_RESULTS,
      children: <></>,
    },
  ];
};
